import { useViewportScroll } from 'framer-motion';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { MouseEventHandler, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { BrandSitesV2Theme } from './GlobalStyle';
import { RightUpArrow } from '../../svgs/RightUpArrow';
import { CDSColor, CDSFont, fontCss, getColor } from 'design-system-webview';

interface Props {
  textColor?: string;
  forceMobile?: boolean;
}

const PRO_URL = 'https://cleaninglab-official.notion.site/fab33235930c479598c3b88c3cb169ba';

export default function Header({ textColor = 'rgba(0, 0, 0, 0.85)', forceMobile = false }: Props) {
  const { scrollY } = useViewportScroll();
  const [isScrollOnTop, setIsScrollOnTop] = useState(true);
  const [isFolded, setIsFolded] = useState(true);
  const router = useRouter();
  const scrollableElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsScrollOnTop(scrollY.get() === 0);
    scrollY.onChange((value) => {
      setIsScrollOnTop(value === 0 && getComputedStyle(document.body).position !== 'fixed');
    });
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (isFolded) return;
      if (window.innerWidth > Number(BrandSitesV2Theme!.brandSitesV2.breakpoints.tablet.replace('px', ''))) {
        setIsFolded(true);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [isFolded]);

  // useEffect(() => {
  //   const scrollableElement = scrollableElementRef.current;
  //   if (!scrollableElement) return;

  //   if (!isFolded) lock(scrollableElement);
  //   else unlock(scrollableElement);

  //   return () => unlock(scrollableElement);
  // }, [isFolded]);

  useEffect(() => {
    if (!isFolded) {
      document.body.style.cssText = `
      overscroll-behavior-y: none;
      -webkit-overflow-scrolling: touch;

      position: fixed;
      top: -${window.scrollY}px;

      overflow-y: scroll;
      width: 100%;`;
    } else {
      const scrollY = document.body.style.top;
      document.body.style.cssText = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }

    // return () => {
    //   const scrollY = document.body.style.top;
    //   document.body.style.cssText = '';
    //   window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    // };
  }, [isFolded]);

  const onClickLink: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (e.currentTarget.pathname === router.pathname) {
      setIsFolded(true);
    }
  };

  return (
    <Container $isScrollOnTop={isScrollOnTop} $isFolded={isFolded} $textColor={textColor} $forceMobile={forceMobile}>
      <OuterWrapper>
        <InnerWrapper>
          <LeftSide>
            <Link href="/" passHref>
              <Logo onClick={onClickLink}>
                <FakeText>청소연구소</FakeText>
                <LogoIcon>{LogoSvg}</LogoIcon>
              </Logo>
            </Link>
            <Items
            // animate={hasAnimation ? { opacity: [0, 0, 1] } : {}}
            // transition={{ duration: 1, times: [0, 0.6, 1], ease: [0.65, 0, 0.35, 1] }}
            // exit={{ opacity: 1 }}
            >
              <Link href="/about" passHref>
                <LeftItem onClick={onClickLink}>청연이야기</LeftItem>
              </Link>
              <LeftDropDownItem>
                <DropDownBox>
                  <LeftItem>생활 청소</LeftItem>
                  <ApplyProBox>
                    <ApplyProBoxInner>
                      <Link href="/home_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>가사 청소</RightItemText>
                        </RightItem>
                      </Link>
                      <Link href="/office_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>사무실 청소</RightItemText>
                        </RightItem>
                      </Link>
                    </ApplyProBoxInner>
                  </ApplyProBox>
                </DropDownBox>
              </LeftDropDownItem>
              <LeftDropDownItem>
                <DropDownBox>
                  <LeftItem>전문 청소</LeftItem>
                  <ApplyProBox>
                    <ApplyProBoxInner>
                      <Link href="/moving_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>이사·입주 청소</RightItemText>
                        </RightItem>
                      </Link>
                      {/* <Link href="/" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>에어컨 청소</RightItemText>
                        </RightItem>
                      </Link> */}
                    </ApplyProBoxInner>
                  </ApplyProBox>
                </DropDownBox>
              </LeftDropDownItem>
              <Link href="/store" passHref>
                <LeftItem onClick={onClickLink}>플러스샵</LeftItem>
              </Link>
            </Items>
          </LeftSide>
          <RightSide>
            <Items
            // animate={hasAnimation ? { opacity: [0, 0, 1] } : {}}
            // transition={{ duration: 1, times: [0, 0.6, 1], ease: [0.65, 0, 0.35, 1] }}
            // exit={{ opacity: 1 }}
            >
              <DropDownBox>
                <RightItem style={{ marginRight: '40px' }}>제휴·복지</RightItem>
                <ApplyProBox>
                  <ApplyProBoxInner>
                    <Link href="/commerce/store-partnership-inquiry" passHref>
                      <RightItem onClick={onClickLink}>
                        <RightItemText>입점 문의</RightItemText>
                      </RightItem>
                    </Link>
                    <Link href="/b2b_introduction" passHref>
                      <RightItem onClick={onClickLink}>
                        <RightItemText>기업복지 문의</RightItemText>
                      </RightItem>
                    </Link>
                    <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
                      <RightItem onClick={onClickLink} target={'_blank'}>
                        <RightItemText>제휴 문의</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                  </ApplyProBoxInner>
                </ApplyProBox>
              </DropDownBox>
              <DropDownBox>
                <RightItem>매니저·프로 모집</RightItem>
                <ApplyProBox>
                  <ApplyProBoxInner>
                    <Link href="/manager_apply" passHref>
                      <RightItem onClick={onClickLink} target="_blank">
                        <RightItemText>{'청연매니저'}</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                    <Link href="https://playful-lycra-822.notion.site/1-bf06ca4bfff74ed297c912f5463ddf1f" passHref>
                      <RightItem target={'_blank'} rel="noopener noreferrer">
                        <RightItemText>{'청연프로'}</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                  </ApplyProBoxInner>
                </ApplyProBox>
              </DropDownBox>
            </Items>
            <Hamburger onClick={() => setIsFolded((prev) => !prev)}>{isFolded ? HamburgerSvg : CloseSvg}</Hamburger>
          </RightSide>
        </InnerWrapper>
      </OuterWrapper>
      <UnFoldContainer className="menu" ref={scrollableElementRef}>
        <UnFoldWrapper>
          <AnchorGroup>
            <AnchorGroupName>회사</AnchorGroupName>
            <Link href="/about" passHref>
              <Anchor onClick={onClickLink}>청연 이야기</Anchor>
            </Link>
            <Link href="/news" passHref>
              <Anchor onClick={onClickLink}>보도자료</Anchor>
            </Link>
            <Link href={PRO_URL} passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                채용공고
              </Anchor>
            </Link>
            <Link href="https://blog.cleaninglab.co.kr" passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                <AnchorTextWrapper>
                  청연 블로그
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>서비스</AnchorGroupName>
            <Link href="/home_clean" passHref>
              <Anchor onClick={onClickLink}>가사 청소</Anchor>
            </Link>
            <Link href="/office_clean" passHref>
              <Anchor onClick={onClickLink}>사무실 청소</Anchor>
            </Link>
            <Link href="/moving_clean" passHref>
              <Anchor onClick={onClickLink}>이사·입주 청소</Anchor>
            </Link>
            <Link href="/store" passHref>
              <Anchor onClick={onClickLink}>플러스샵</Anchor>
            </Link>
            <Link href="/gift" passHref>
              <Anchor onClick={onClickLink}>선물하기</Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>제휴안내</AnchorGroupName>
            <Link href="/commerce/store-partnership-inquiry" passHref>
              <Anchor onClick={onClickLink}>입점 문의</Anchor>
            </Link>
            <Link href="/b2b_introduction" passHref>
              <Anchor onClick={onClickLink}>기업복지 문의</Anchor>
            </Link>
            <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                <AnchorTextWrapper>
                  제휴 문의
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>모집</AnchorGroupName>
            <Link href="/manager_apply" passHref>
              <Anchor onClick={onClickLink} target="_blank">
                <AnchorTextWrapper>
                  청연매니저
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
            <Link href="https://playful-lycra-822.notion.site/1-bf06ca4bfff74ed297c912f5463ddf1f" passHref>
              <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                <AnchorTextWrapper>
                  청연프로
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>지원안내</AnchorGroupName>
            <Link href={`${process.env.NEXT_PUBLIC_VIEW_URL}/partner/intro`} passHref>
              <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                <AnchorTextWrapper>
                  청연 파트너
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
            <Link href="/user-partner" passHref>
              <Anchor onClick={onClickLink} target="_blank">
                <AnchorTextWrapper>
                  청연 추천프로그램
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
        </UnFoldWrapper>
      </UnFoldContainer>
    </Container>
  );
}

const OuterWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 24px;
  flex-shrink: 0;
`;

const InnerWrapper = styled.div`
  height: 64px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.a`
  margin-right: 52px;

  svg path {
    /* transition: 0.2s; */
  }
`;

const LogoIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FakeText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const Items = styled.div`
  display: flex;
`;

const LeftItem = styled.a`
  margin-right: 40px;
  ${CDSFont('Body/B2_SB')}

  &:hover {
    color: #00bed6;
  }
`;

const LeftDropDownItem = styled.div``;

const RightItem = styled.a`
  ${CDSFont('Body/B4_R')}

  &:hover {
    color: #00bed6;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
`;

const UnFoldContainer = styled.div`
  padding: 0 24px;
  overflow-y: scroll;
  background: #ffffff;
  height: 100%;
`;

const UnFoldWrapper = styled.div`
  display: none;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
  padding-top: 32px;
  padding-bottom: 120px;
  height: fit-content;
`;

const AnchorGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 22px;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

const AnchorGroupName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 20px;
`;

const Anchor = styled.a`
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 17px;
  line-height: 140%;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 30px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const Container = styled.header<{
  $isScrollOnTop: boolean;
  $isFolded: boolean;
  $textColor: string;
  $forceMobile: boolean;
}>`
  height: 64px;
  margin-top: -64px;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: rgba(255, 255, 255, 0);
  font-weight: 400;
  color: ${({ $textColor }) => $textColor};
  backdrop-filter: blur(0px);
  z-index: ${BrandSitesV2Theme.brandSitesV2!.headerZIndex};
  display: flex;
  flex-direction: column;
  transition: 0.2s background-color, 0.2s backdrop-filter;

  ${OuterWrapper} {
    transition: 0.2s;
    box-shadow: rgb(51 51 102 / 7%) 0px 1px 0px 0px;
  }

  ${Hamburger} svg path,
    ${Logo} svg path {
    transition: 0.2s;
    fill: ${({ $textColor }) => $textColor};
  }

  ${({ $isFolded }) =>
    $isFolded &&
    css`
      &:hover {
        color: rgba(0, 0, 0, 0.85);
        background-color: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(8px);

        ${Logo} svg path {
          fill: #00bed6;
        }

        ${Hamburger} svg path {
          fill: rgba(0, 0, 0, 0.85);
        }
      }
    `}

  ${({ $isScrollOnTop, $isFolded }) =>
    !$isScrollOnTop &&
    $isFolded &&
    css`
      color: rgba(0, 0, 0, 0.85);
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(8px);

      ${OuterWrapper} {
        box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.8);
        /* box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28); */
      }

      ${Logo} svg path {
        fill: #00bed6;
      }

      ${Hamburger} svg path {
        fill: rgba(0, 0, 0, 0.85);
      }
    `};

  ${({ $isFolded, $forceMobile, theme }) =>
    !$isFolded &&
    css`
      color: rgba(0, 0, 0, 0.85);

      @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.tablet}`}) {
        position: fixed;
        margin-top: 0;
        height: 100vh;
        background-color: rgba(255, 255, 255, 1);
        backdrop-filter: blur(0px);

        ${UnFoldWrapper} {
          display: block;
        }

        ${Logo} svg path {
          fill: #00bed6;
        }

        ${Hamburger} svg path {
          fill: rgba(0, 0, 0, 0.85);
        }
      }
    `}

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.tablet}`}) {
      ${Hamburger} {
        display: inline-block;
      }

      ${Items} {
        display: none;
      }

      ${InnerWrapper} {
        max-width: ${theme.brandSitesV2!.containerWidths!.tablet};
      }

      ${UnFoldWrapper} {
        max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
      }

      ${AnchorGroup} {
        margin-bottom: 20px;
      }
    }
  `}

    ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.mobile}`}) {
      ${UnFoldWrapper} {
        padding-top: 30px;
      }
    }
  `}

  ${({ $forceMobile }) =>
    $forceMobile &&
    css`
      max-width: 430px;
    `}
`;

const DropDownBox = styled.div`
  position: relative;
  display: inline-block;

  &:hover {
    ${LeftItem} {
      color: #00bed6;
    }

    ${RightItem} {
      color: #00bed6;
    }
  }
`;

const ApplyProBox = styled.div`
  ${fontCss('Body/B3_SB')}
  display: none;

  position: absolute;
  top: 0;
  left: -18px;

  padding-top: 30px;

  ${DropDownBox}:hover & {
    display: block;
  }
`;

const ApplyProBoxInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  min-width: 127px;
  padding: 20px;

  background-color: ${getColor('Surface/Primary')};
  border-radius: 8px;

  box-shadow: 0 2px 30px 0 #0000000d;
`;

const RightItemText = styled.div`
  display: inline-block;
  color: ${CDSColor('Text/Primary')};
  ${CDSFont('Body/B3_SB')}

  &:hover {
    color: #00bed6;
  }
`;

const RightUpArrowWrapper = styled.div`
  display: inline-block;
  margin-left: 2px;

  svg {
    position: relative;
    top: -4px;

    path {
      ${RightItem}:hover & {
        fill: #00bed6;
      }
    }
  }
`;

const LogoSvg = (
  <svg width="120" height="24" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2075_27434)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0056 6.55256H42.6474V0H45.3823V12.5372H42.6474V8.82837H39.0056V6.55256ZM36.6767 0.414517H30.7284V2.57591H36.6767V0.414517ZM39.6991 12.5749C36.5805 12.5749 34.0423 15.113 34.0423 18.2316C34.0423 21.3502 36.5805 23.8883 39.6991 23.8883C42.8177 23.8883 45.3558 21.3502 45.3558 18.2316C45.3558 15.113 42.8177 12.5749 39.6991 12.5749ZM39.6991 21.4465C37.9256 21.4465 36.4828 20.0037 36.4828 18.2302C36.4828 16.4567 37.9256 15.0139 39.6991 15.0139C41.4725 15.0139 42.9153 16.4567 42.9153 18.2302C42.9153 20.0037 41.4725 21.4465 39.6991 21.4465ZM76.5391 7.48748L76.387 9.7619H79.4818V14.3289H82.1846V0.0363145H79.4818V3.04329H76.387L76.5391 5.31911H79.4818V7.48748H76.5391ZM54.2805 10.1932H57.0167V14.4825H65.3972V16.7569H46.6632V14.4825H54.2805V10.1932ZM72.487 13.2669H69.7521V20.2157H70.2935H72.487H82.807V17.9413H72.487V13.2669ZM39.8958 10.0101L38.5702 12.0529C36.9042 11.5799 34.8628 10.4832 33.7367 8.50455C33.2121 9.60269 32.3637 10.5976 31.1219 11.4515C30.2665 12.0404 29.4139 12.459 28.7721 12.7311L27.5023 10.7748C28.7539 10.2934 31.8712 8.71525 32.1126 5.69571H28.2726V3.53432H39.0028V5.69571H35.2046C35.3316 7.11339 35.9944 8.2478 37.3953 9.07106C38.5409 9.74362 39.7102 9.97664 39.8958 10.0101ZM55.5837 5.19917C56.4195 6.95033 58.2572 9.17731 62.3093 10.6173L63.5972 8.63731C57.5126 6.68734 57.2076 2.93719 57.1696 2.47121L57.1674 2.44475V0.414517H56.3511H54.8791H54.0628V2.44056L54.0626 2.44227C54.0254 2.82726 53.6602 6.60727 47.6107 8.59545L48.8944 10.5713C52.8628 9.12987 54.7158 6.93219 55.5837 5.19917ZM69.9949 0.471498C73.1135 0.471498 75.6516 3.00964 75.6516 6.12824C75.6516 9.24685 73.1149 11.7836 69.9949 11.785C66.8763 11.785 64.3381 9.24685 64.3381 6.12824C64.3381 3.00964 66.8763 0.471498 69.9949 0.471498ZM69.9963 2.91196C68.2228 2.91196 66.78 4.35475 66.78 6.12824C66.78 7.90173 68.2228 9.34313 69.9963 9.34452C71.7698 9.34452 73.2125 7.90173 73.2125 6.12824C73.2125 4.35475 71.7698 2.91196 69.9963 2.91196ZM102.003 9.76186H98.2925C99.1786 5.86325 99.0405 2.15721 99.0321 1.98279V0.891624H85.867V3.16604H96.4465C96.4242 4.58511 96.2832 7.19023 95.6344 9.76046H83.5577V12.0349H91.4553V20.2144H94.1902V12.0377H102.003V9.76186ZM111.875 10.1932V14.4825H119.95V16.7569H101.064V14.4825H109.139V10.1932H111.875ZM110.48 5.19917C111.315 6.95173 113.154 9.17731 117.208 10.6187L118.493 8.6387C112.408 6.68872 112.103 2.93853 112.065 2.4726L112.063 2.44614V0.414517H111.247H109.775H108.959V2.44056L108.958 2.44227C108.921 2.82727 108.556 6.60727 102.507 8.59545L103.789 10.5713C107.759 9.12987 109.612 6.93219 110.48 5.19917ZM13.5251 6.36971C14.7 4.96459 16.4665 4.07018 18.4409 4.07018C21.9795 4.07018 24.8484 6.93762 24.8498 10.4762C24.8498 14.0148 21.9809 16.8837 18.4423 16.8837C15.0112 16.8837 12.2107 14.1865 12.0433 10.7972L9.80791 11.5283L12.0907 14.6748L9.05581 16.8753L6.76186 13.712L4.46791 16.8753L1.43302 14.6748L3.70884 11.5353L0 10.3227L1.16512 6.75901L4.88512 7.97576V4.07018H8.63302V7.96878L13.5251 6.36971ZM15.7828 10.4762C15.7828 11.9441 16.973 13.1344 18.4409 13.1344C19.9102 13.1344 21.0991 11.9441 21.0991 10.4762C21.0991 9.00832 19.9088 7.81808 18.4409 7.81808C16.973 7.81808 15.7828 9.00832 15.7828 10.4762Z"
        fill="#000000"
      />
    </g>
    <defs>
      <clipPath id="clip0_2075_27434">
        <rect width="120" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HamburgerSvg = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.19995 5.00078C3.19995 4.61418 3.51335 4.30078 3.89995 4.30078H21.9C22.2866 4.30078 22.6 4.61418 22.6 5.00078C22.6 5.38738 22.2866 5.70078 21.9 5.70078H3.89995C3.51335 5.70078 3.19995 5.38738 3.19995 5.00078ZM3.19995 12.5008C3.19995 12.1142 3.51335 11.8008 3.89995 11.8008H21.9C22.2866 11.8008 22.6 12.1142 22.6 12.5008C22.6 12.8874 22.2866 13.2008 21.9 13.2008H3.89995C3.51335 13.2008 3.19995 12.8874 3.19995 12.5008ZM3.89995 19.3008C3.51335 19.3008 3.19995 19.6142 3.19995 20.0008C3.19995 20.3874 3.51335 20.7008 3.89995 20.7008H21.9C22.2866 20.7008 22.6 20.3874 22.6 20.0008C22.6 19.6142 22.2866 19.3008 21.9 19.3008H3.89995Z"
      fill="#262626"
    />
  </svg>
);

const CloseSvg = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9652 19.003C19.2386 19.2764 19.6818 19.2764 19.9552 19.003C20.2285 18.7296 20.2285 18.2864 19.9552 18.0131L13.9095 11.9674L19.9552 5.92171C20.2285 5.64835 20.2285 5.20513 19.9552 4.93176C19.6818 4.6584 19.2386 4.6584 18.9652 4.93176L12.9195 10.9774L6.87369 4.93159C6.60032 4.65822 6.1571 4.65822 5.88374 4.93159C5.61037 5.20495 5.61037 5.64817 5.88374 5.92154L11.9296 11.9674L5.88374 18.0132C5.61037 18.2866 5.61037 18.7298 5.88374 19.0032C6.1571 19.2766 6.60032 19.2766 6.87369 19.0032L12.9195 12.9573L18.9652 19.003Z"
      fill="#262626"
    />
  </svg>
);

const AnchorTextWrapper = styled.div`
  > svg {
    margin: 0 0 6px 2px;
  }
`;

const RightUpArrowSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.741644 0C0.410273 0 0.141644 0.268629 0.141644 0.6C0.141644 0.931371 0.410273 1.2 0.741644 1.2H4.3782L0.169821 5.52825C-0.0611802 5.76583 -0.0558465 6.14569 0.181735 6.37669C0.419316 6.60769 0.799178 6.60236 1.03018 6.36478L5.13243 2.14569V5.59665C5.13243 5.92802 5.40106 6.19665 5.73243 6.19665C6.0638 6.19665 6.33243 5.92802 6.33243 5.59665V0.6V0H5.73243H0.741644Z"
      fill="#262626"
    />
  </svg>
);
